import { Map } from 'immutable'
import {
  getSectionTotalKey,
  getAggregateTotalKey
} from '../components/sections/section'
import { otherIncomeSectionId } from '../components/sections/Section7Income'

export const UPDATE_SECTION_FORM_LINES = 'app/update-section-form-lines'
export const UPDATE_SECTION_TOTAL = 'app/update-section-total'
export const UPDATE_AGGREGATE = 'app/update-aggregate'
export const UPDATE_HELP_LEVEL = 'app/update-help-level'

const initialState = Map({
  [getSectionTotalKey(1)]: 0,
  [getSectionTotalKey(2)]: 0,
  [getSectionTotalKey(3)]: 0,
  [getSectionTotalKey(otherIncomeSectionId)]: 0,
  helpLevel: 1
})

/**
 *
 * @param state
 * @param action
 * @returns {*|Map<K, V>|Map<string, V>}
 */
export default function reducer (state = initialState, action) {
  switch (action.type) {
    case UPDATE_SECTION_FORM_LINES: {
      return state.set(action.reduxKey, action.formLines)
    }
    case UPDATE_SECTION_TOTAL: {
      return state.set(getSectionTotalKey(action.sectionNumber), action.total)
    }
    case UPDATE_AGGREGATE: {
      return state.set(getAggregateTotalKey(action.id), action.total)
    }
    case UPDATE_HELP_LEVEL: {
      return state.set('helpLevel', action.level)
    }
    default: {
      return state
    }
  }
}

export function updateSectionFormLines (reduxKey, formLines) {
  return {
    type: UPDATE_SECTION_FORM_LINES,
    reduxKey,
    formLines
  }
}

export function updateSectionTotal (total, sectionNumber) {
  return {
    type: UPDATE_SECTION_TOTAL,
    total,
    sectionNumber
  }
}

export function updateAggregate (total, id) {
  return {
    type: UPDATE_AGGREGATE,
    total,
    id
  }
}

export function updateHelpLevel (level) {
  return {
    type: UPDATE_HELP_LEVEL,
    level
  }
}



// WEBPACK FOOTER //
// ./src/redux/app-reducer.js